import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={item.label} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            )}
            {isLast || !item.to ? (
              <span className={isLast ? 'text-foreground-700 font-medium' : ''}>
                {item.label}
              </span>
            ) : (
              <Link to={item.to} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}